import angular from 'angular';
import uiRouter from '@uirouter/angularjs';

import settingsComponent from './settings.component';
import accountPassComponent from './component/account-pass/account-pass.component';
import transactionPassComponent from './component/transaction-authentication/transaction-pass/transaction-pass.component';
import googleAuthenticationComponent from './component/transaction-authentication/google-authentication/google-authentication.component';
import usernameComponent from './component/username/username.component';
import bankAccountComponent from './component/bank-account/bank-account.component';
import successModalComponent from './component/bank-account/success.modal.component';
import errorModalComponent from './component/bank-account/error.modal.component';
import transactionAuthenticationComponent  from './component/transaction-authentication/transaction-authentication.component';
import avatarComponent from './component/avatar/avatar.component';

let settingsModule = angular.module('settings', [
  uiRouter
])
.config(($stateProvider) => {
  'ngInject';
  $stateProvider
  .state('settings', {
    url: '/settings',
    component: 'settings',
    resolve: {
      authenticate: (SecurityService) => {
        SecurityService.authenticate();
      }
    }
  })
  ;
})
.component('settings', settingsComponent)
.component('accountPass', accountPassComponent)
.component('transactionPass', transactionPassComponent)
.component('googleAuthentication', googleAuthenticationComponent)
.component('username', usernameComponent)
.component('bankAccount', bankAccountComponent)
.component('transactionAuthentication', transactionAuthenticationComponent)
.component('successModalComponent', successModalComponent)
.component('errorModalComponent', errorModalComponent)
.component('avatar', avatarComponent)
.name;

export default settingsModule;


// WEBPACK FOOTER //
// ./client/app/pages/settings/settings.js